<template>
  <div class="forgotPasswordContainer">
    <div class="grid imgGrid">
      <img
        class="imgContainer"
        src="@/assets/images/mosquita_forgotten_password.png"
      />
      <p class="nunitoBold subheaderText">
        {{ $t('k_forgot_password_title') }}
      </p>
      <p class="ralewayRegular subheaderText2">
        {{ $t('k_description_password') }}
      </p>
    </div>

    <form action="#" @submit.prevent="submit">
      <div class="formContainer mt-5">
        <div class="formElement">
          <label class="ralewayRegular formInputLabel" for="email">{{
            $t('k_email_type')
          }}</label>
          <input
            class="formInput ralewayRegular"
            type="text"
            name="email"
            v-model="email"
            v-bind:placeholder="$t('k_email_type')"
          />
        </div>
      </div>

      <div class="grid mt-10 stButtonGrid">
        <div class="stButton registerButton">
          <div class="stButtonCaption nunitoBold" v-on:click="submit()">
            {{ $t('k_reset_password') }}
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="signText ralewayRegular">
          {{ $t('k_password_remember') }} </span
        ><router-link to="/login"
          ><span class="signLink ralewayBold">
            {{ $t('k_login_subtitle') }}</span
          ></router-link
        >
      </div>
    </form>
  </div>
</template>

<script>
import api from '../plugins/api'
import { trackEvent } from '../plugins/analyticsTracker'

export default {
  data() {
    return {
      email: '',
      confirmMessage: ''
    }
  },
  methods: {
    submit: async function() {
      trackEvent(this.$constants.WEB_CHANGEPWD_RESTORE)
      try {
        this.confirmMessage = ''
        await api.post(
          '/user/passwordReset',
          {
            email: this.email,
            lang: this.$i18n.locale
          },
          {
            headers: {
              Authorization: process.env.VUE_APP_CONTROL_KEY
            }
          }
        )
        this.confirmMessage = 'Email sent correctly'
        this.$router.push({
          path: 'reset-password-done'
        })
      } catch (error) {
        console.log(error)
        await this.$store.dispatch('setError', {
          errorKey: 'k_generic_error_title',
          errorSubKey: 'k_reset_password_fail',
          errorImage: '@/assets/images/mosquita_generic_error.png',
          redirect: '/login'
        })
        this.$router.push('error')
      }
    },
    goBack: function() {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss">
.forgotPasswordContainer {
  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .hrLine {
    width: 100%;
    text-align: center;
    border-bottom: 0.2px solid var(--line2);
    line-height: 0.1em;
    margin: 10px 0 20px;
    grid-row: 1;
    grid-column: 2/12;
  }

  .hrLine span {
    padding: 0 10px;
    background: #fff;
    color: var(--line1);
    font-size: 0.5em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
    .stButtonGrid {
      max-width: 600px;
      margin: auto;
    }

    .formContainer {
      max-width: 600px;
      margin: auto;
    }
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
